import React from "react";
import {  Modal } from "react-bootstrap";

import WhiteGreenButton from "../../jsx/components/button/whiteGreenButton";
import imageLogo from '../../media/images/logo.png'
const ErrorResponseModal = ({
    modalStatus,
    text,
    onClick,
   

}) => {
  return (
    <Modal  
    aria-labelledby="contained-modal-title-vcenter"
    centered className="fade"  show={modalStatus} style={{}}>
      
        <Modal.Body className="d-flex justify-content-center align-items-center flex-column">
            <img src={imageLogo} style={{width:"100px"}} className="mb-4"/>
        <p className="fs-5 mb-3" style={{textAlign:'center',fontSize:'18px',fontWeight:'600'}}>
     
        {text}
               </p>

  
               <WhiteGreenButton
            onClick={onClick}
            buttonName={"OK"}
            className={'white-background-btn w-100 '}
            variant={'primary'}
          />
        </Modal.Body>

    
         
        
       
     
    </Modal>
  );
};

export default ErrorResponseModal;
